tmDocumentReady = function () {
    return {
        isPosthogCallingFeatureFlags: false,
        highlightedActivityHtml: null,
        setupVisitorId: function () {
            if (typeof tmVisitorStore !== 'undefined') {
                let currentIdentifier = tmVisitorStore.getDetail('identifier');
                if (!currentIdentifier) {
                    tmVisitorStore.saveDetails('', '', '', crypto.randomUUID());
                }
            }
        },
        ttdHighlightActivity: function () {
            let ttdHighlightActivityId = typeof tmUtils !== "undefined" ? tmUtils.getParameterFromUrl('q_activity_id', window.location.href) : null;
            if (ttdHighlightActivityId !== null && ttdHighlightActivityId > 0) {
                jQuery.ajax({
                    type: "post",
                    url: ajaxurl,
                    data: {
                        "action": "get_highlighted_activity_item",
                        "tm_product_id": ttdHighlightActivityId,
                    },
                    success: function(response){
                        tmDocumentReady.highlightedActivityHtml = response;
                        tmDocumentReady.updateHighlightedActivityContentToSelector();
                    }
                })
            }
        },
        updateHighlightedActivityContentToSelector: function () {
            if (tmDocumentReady.highlightedActivityHtml !== null) {
                jQuery('.right-section .listing-group').prepend(tmDocumentReady.highlightedActivityHtml);
                jQuery(document).trigger('tmActivitiesSubsetListRefreshed');
            }
        },
        setInternalUser: function () {
            try {
                let isInternalUser = typeof tmUtils !== "undefined" ? tmUtils.getParameterFromUrl('set-internal-user', window.location.href) : null;
                if (isInternalUser !== null) {
                    tmVisitorStore.setAsInternalUser();
                }
            } catch (e) {}
        },
        setInternalUserForPostHog: function () {
            try {
                if (tmVisitorStore.isInternalUser()) {
                    window.posthog.register({
                        'is_tester': true,
                    });
                }
            } catch (e) {}
        },
        saveTagsToCookie: function () {
            if (typeof tmBlogRequestJsVars !== 'undefined') {
                if (tmBlogRequestJsVars.hasOwnProperty('tm_current_product_id')) {
                    tmVisitorStore.addTag('p-' + tmBlogRequestJsVars.tm_current_product_id)
                }
            }
        },
        loadPosthogFeatureFlags: function () {
            /*if (tmDocumentReady.isPosthogCallingFeatureFlags) {
                return;
            }
            if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
                if (typeof posthog.getFeatureFlag('xxx') === 'undefined' /!* use any one active flag here. So we do not double load *!/) {
                    tmDocumentReady.isPosthogCallingFeatureFlags = true;
                    posthog.reloadFeatureFlags()
                }
                else {
                    jQuery(document).trigger('postHogFeatureFlagsLoaded'); /!* needed as subsequent request will already have the flags data  *!/
                }
            }*/
        },
       /* applyGtranslateLanguage: function () {
            try {
                let languageCodeFromGetParam = tmUtils.getParameterFromUrl('language', window.location.href);
                if (languageCodeFromGetParam !== null) {
                    doGTranslate('en|' + languageCodeFromGetParam);
                }
            } catch (e) {}
        },*/
        setupForCurrency: function () {
            try {
                let currencyCodeFromGetParam = tmUtils.getParameterFromUrl('currency', window.location.href); // todo: remove later
                if (currencyCodeFromGetParam === null) {
                    currencyCodeFromGetParam = tmUtils.getParameterFromUrl('q_currency', window.location.href);
                }
                if (tmCurrency.getTmCurrencyByCode(currencyCodeFromGetParam) !== null) {
                    tmCurrency.changeCurrency(currencyCodeFromGetParam);
                }
                else {
                    tmCurrency.changeCurrency(tmVisitorStore.getCurrency());
                }
            } catch (e) {}
        },

        /*runObservers: function () {
            try {
                let observer = new MutationObserver((mutationsList, observer) => {
                    observer.disconnect(); // temporarily stop observing, so it does not loop.
                    tmCurrency.currencyUpdateEls();
                    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true});
                });
                observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true});
            } catch (e) {}
        }*/

        listenForPosthogToInit: function () {
            let posthogInitCounter = 1;
            try {
                (function waitForPosthog() {
                    if (window.posthog) {
                        tmDocumentReady.setInternalUserForPostHog();
                        if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
                            window.posthog.onFeatureFlags(function (flags) {
                                tmDocumentReady.isPosthogCallingFeatureFlags = false;
                                jQuery(document).trigger('postHogFeatureFlagsLoaded');
                            });
                        }
                        jQuery(document).trigger('postHogInitDone');
                    }
                    else {
                        posthogInitCounter ++;
                        if (posthogInitCounter <= 50) {
                            setTimeout(waitForPosthog, 100);
                        }
                    }
                })();
            } catch (e) {}
        },
    }
}(window);

/* Trigger Items on document ready */
(function() {
    jQuery(document).ready(function () {
        tmDocumentReady.setupVisitorId();
        tmDocumentReady.ttdHighlightActivity();
        /*tmDocumentReady.listenForPosthogToInit();*/
        tmDocumentReady.setInternalUser();
        tmDocumentReady.saveTagsToCookie();
        //tmDocumentReady.applyGtranslateLanguage();
        tmVisitorStore.setAttributionCookies();
        tmVisitorStore.setNavigationCookies();
        tmDocumentReady.setupForCurrency();
        //tmDocumentReady.runObservers();
    });

    jQuery(document).on('postHogLoadFeatureFlags', function() {
        tmDocumentReady.loadPosthogFeatureFlags();
    });

    jQuery(document).on('tmActivitiesFiltersApplied', function() {
        tmDocumentReady.updateHighlightedActivityContentToSelector();
    });

    jQuery(document).on('postHogInitDone', function() {
        /*if (typeof tmBlogRequestJsVars === 'undefined') {
            return;
        }
        if (!tmBlogRequestJsVars.tm_is_automated_site) {
            jQuery(document).trigger('postHogLoadFeatureFlags');
        }*/
    });

})();

